export default "__VITE_ASSET__B35oc4Sn__"